import { sanitizeString } from '@kissui/helpers/src/utils'
import { getMergedProductCoffeeData } from './product.coffee.dto'
import { getMergedProductMachineData } from './product.machine.dto'
import { VARIATION_PLP } from '@kissui/components/src/sku/constants'
import { getMergedProductGiftCardData } from './product.giftCard.dto'
import { getMergedProductAccessoryData } from './product.accessory.dto'
import { apiOverride } from '@kissui/components/src/sku/services'
import {
    ECAPI_TYPE_ACCESSORY,
    ECAPI_TYPE_CAPSULE,
    ECAPI_TYPE_GIFT_CARD,
    ECAPI_TYPE_MACHINE
} from '@kissui/helpers/src/catalog'

export const getMergedProductData = (
    product,
    pageBuilderProductProps,
    pageBuilderProps,
    priceFormatter,
    currency
) => {
    const { options } = pageBuilderProps
    const {
        variant = {},
        labels = [],
        strikethrough_price,
        additional_message,
        additional_message_icon,
        additional_message_link,
        contact_cta
    } = pageBuilderProductProps || {}

    // lists header props not coming from this.props
    let data = {
        sku: product.internationalId,
        technologies: product.technologies,
        longSku: product.id,
        name: product.name,
        headline: sanitizeString(product.headline),
        sales_multiple: product.salesMultiple,
        unit_quantity: product.unitQuantity,
        type: product.type,
        category_name: product.rangeData?.name || '',
        label_range: product.rangeData?.name || '',
        price: product.price ? priceFormatter.short(currency, product.price) : null,
        rawPrice: product.price,
        strikethrough_price: strikethrough_price || '',
        variation: VARIATION_PLP,
        image_alt_text: product.name,
        image: product.images?.icon || product.images?.push || product.images?.main,
        additional_message: additional_message || '',
        additional_message_icon: additional_message_icon || '',
        additional_message_link: additional_message_link || {},
        contact_cta: contact_cta || {},
        ...apiOverride(product, pageBuilderProductProps)
    }

    if (labels && labels.length) {
        data.labels = labels
    }

    if (product.highlighted) {
        data.highlighted = product.highlighted
    }

    let dataTransformObjectProductType = {}
    if (product.type === ECAPI_TYPE_CAPSULE) {
        dataTransformObjectProductType = getMergedProductCoffeeData(
            product,
            pageBuilderProductProps,
            pageBuilderProps,
            priceFormatter,
            currency
        )
    } else if (product.type === ECAPI_TYPE_MACHINE) {
        dataTransformObjectProductType = getMergedProductMachineData(
            product,
            pageBuilderProductProps,
            pageBuilderProps
        )
    } else if (product.type === ECAPI_TYPE_ACCESSORY) {
        dataTransformObjectProductType = getMergedProductAccessoryData(
            product,
            pageBuilderProductProps,
            pageBuilderProps
        )
    } else if (product.type === ECAPI_TYPE_GIFT_CARD) {
        dataTransformObjectProductType = getMergedProductGiftCardData(
            product,
            pageBuilderProductProps,
            pageBuilderProps
        )
    }

    return {
        ...product,
        ...options,
        ...variant,
        ...data,
        ...dataTransformObjectProductType
    }
}
